// eslint-disable-next-line no-unused-vars
import $axios from "@/utils/axios";
import store from "@/store";
import _ from 'lodash';
let userInfoResolved = false

// 菜单interface
// eslint-disable-next-line no-unused-vars
const menuItem = {
  funcId: '',
  hasAuth: true,
  url: '',
  param: ''
}
const filterMenu = (tree) => {
  return tree.map((item) => {
    const children = item.children.filter(child => child.type === "M")
    return {
      ...item,
      hasAuth: !!children.filter(item => item.hasAuth).length || (!children.length && item.hasAuth)
    }
  }).filter(_ => (_.hasAuth && _.type == 'M')).map(_ => {
    _ = Object.assign({}, _)
    if(_.children) {
      _.children = filterMenu(_.children)
    }
    return _
  })
}

const createMenuMap = menu => {
  let map = {}
  const tree = (m, parentKeys = []) => {
    m.forEach(item => {
      map[item.funcId] = {
        ...item,
        parentKeys
      }
      if (item.children) {
        tree(item.children, [...parentKeys, item.funcId])
      }
    })
    return map
  }

  return tree(menu)
}
function transListDataToTreeData(treeList, list) {
  if (!treeList || !treeList.length) {
    return;
  }
  for (let i = 0; i < treeList.length; i++) {
    let currentRow = treeList[i];
    let newRow = JSON.parse(JSON.stringify(currentRow));
    newRow.children = undefined;
    list.push(newRow);
    transListDataToTreeData(currentRow.children, list);
  }
}

export const getLoginUser = () => {
  if(!userInfoResolved) {
    let headers = {isJsonResponse: 'Y'}
    if(process.env.NODE_ENV === 'development' && process.env.VUE_APP_LOCAL_ACCOUNT_NO) {
      headers = {...headers, lsmyAccount: process.env.VUE_APP_LOCAL_ACCOUNT_NO}
    }
    return $axios.post(`/${process.env.VUE_APP_PROXY_DING_OA}/oaPersonal/getOaPersonalInfo`, null, {
      headers
    }).then(({data}) => {
      const { shortName, no } = data
      const user = {
        ...data,
        code: no,
        nickName: shortName
      }
      store.commit('user/setUserInfo', user)
      console.log(data)
      return Promise.resolve(user)
    }).then((user) => {
      const params = new URLSearchParams()
      params.append('systemSignage', process.env.VUE_APP_APP_ID)
      return $axios.post(`/${process.env.VUE_APP_PROXY_IT_SERVICE}/auth/func/getMenu`, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          lsmyAccount: user.code,
          listType: 'Pc'
        }
      }).then(data => {
        const { content } = data
        let menuArr = []
        transListDataToTreeData(content, menuArr)
        store.commit('user/setMenuArr', menuArr)
        const menu = filterMenu(content)
        store.commit('user/setMenuList', menu)
        store.commit('user/setMenuMap', createMenuMap(menu))
        store.commit('user/setAllMenu', content)
        changeUserInfoResolved(true)
      })
    })
  } else {
    return Promise.resolve()
  }
}

export const changeUserInfoResolved = (val) => {
  userInfoResolved = val
}


